import { FormControl } from '@mui/material';
import { Moment } from 'moment';
import { Controller, FieldValues, Path, PathValue } from 'react-hook-form';
import { DatePicker } from 'v3/shared/components/Inputs/DatePicker/index';
import { ErrorMessage } from 'v3/shared/components/Inputs/styles/defaultStyles';
import { CustomDatePickerProps } from './types';

export const DatePickerFormController = <T extends FieldValues>({
  formControl,
  formControlName,
  label,
  disablePast,
  disableFuture,
  shouldDisableDate,
  fullWidth = true,
  minDate,
  maxDate,
  onChangeDatePicker,
  defaultValue,
}: CustomDatePickerProps<T>) => {
  return (
    <Controller
      name={formControlName}
      control={formControl}
      defaultValue={(defaultValue ?? null) as PathValue<T, Path<T>>}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <FormControl fullWidth={fullWidth}>
            <DatePicker
              label={label}
              value={(value as Moment | null | undefined) ?? null}
              onChangeDatePicker={(val) => {
                onChange(val);
                onChangeDatePicker?.(val);
              }}
              disablePast={disablePast}
              shouldDisableDate={shouldDisableDate}
              minDate={minDate}
              maxDate={maxDate}
              disableFuture={disableFuture}
            />
            <ErrorMessage>{error?.message}</ErrorMessage>
          </FormControl>
        );
      }}
    />
  );
};
